<div class="speedtest-answer">
  <app-icon [size]="'24'" [glyph]="'speedometer'"></app-icon>
</div>
